export enum ContentType {
	BrownCard = "BrownCard",
	CKEditor = "CKEditor",
	Gallery = "Gallery",
	ImageText = "ImageText",
	VideoText = "VideoText",
	Button = "Button",
}
